// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3VP5V","boxTitle":"Qualiphy_boxTitle__3KiAP","box":"Qualiphy_box__SHP2C","toggleWrap":"Qualiphy_toggleWrap__27uvA"};